export default __webpack_public_path__ + "static/media/signInliving.2e95604b.png";